import { type SelectOption } from '@synqo/frontend-component-library';

export type ContainerRentTableModes = 'open' | 'latest';

export const containerRentTableModes: SelectOption<ContainerRentTableModes>[] = [
    {
        name: 'open',
        label: 'Offene Zeiträume',
        value: 'open',
    },
    {
        name: 'latest',
        label: 'Letzte Aufträge',
        value: 'latest',
    },
];
